class HeroImageSlider extends HTMLElement {
  constructor() {
    super();
    this.currentSlide = 0;
    this.slideInterval = null;
  }

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll(".carousel-slide"));
    this.indicators = Array.from(this.querySelectorAll(".indicator"));
    this.initializeCarousel();
    this.startAutoTransition();
  }

  initializeCarousel() {
    this.updateSlideVisibility();
    this.indicators.forEach((indicator, index) => {
      indicator.addEventListener("click", () => {
        this.goToSlide(index);
        this.restartAutoTransition();
      });
    });
  }

  startAutoTransition() {
    this.slideInterval = setInterval(() => {
      this.goToNextSlide();
    }, 4000); // 4 seconds per slide
  }

  goToNextSlide() {
    this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    this.updateSlideVisibility();
  }

  restartAutoTransition() {
    clearInterval(this.slideInterval);
    this.startAutoTransition();
  }

  goToSlide(index) {
    this.currentSlide = index;
    this.updateSlideVisibility();
  }

  updateSlideVisibility() {
    this.slides.forEach((slide, index) => {
      slide.classList.toggle("active", index === this.currentSlide);
    });

    this.indicators.forEach((indicator, index) => {
      indicator.classList.toggle("active", index === this.currentSlide);
    });
  }

  disconnectedCallback() {
    clearInterval(this.slideInterval);
  }
}

customElements.define("hero-image-slider", HeroImageSlider);
